// src/common-services.js

import axios from 'axios'
import Cookies from 'js-cookie' // Ensure you have js-cookie library installed

import { BASE_URL } from './../config'
// const schoolCode = 'stage9'
// const loginId = 'swipetouch'
// Function to make API requests
export const apiService = async (url, method = 'GET', data = {}, headers = {}) => {
  try {
    const response = await axios({
      method: method,
      url: url,
      data: method !== 'GET' ? data : {}, // Step 1: Only send data in non-GET requests
      headers: {
        'Content-Type': method !== 'GET' ? 'application/json' : undefined, // Step 2: Only set Content-Type for non-GET requests
        ...headers, // Step 3: Additional headers can be added dynamically
      },
    })
    return response.data // Step 4: Return response data
  } catch (error) {
    console.error('API Service Error:', error.response ? error.response.data : error.message) // Step 5: Log error details
    throw error // Step 6: Re-throw the error for handling in the calling function
  }
}
// Function to get a cookie value by name, or set School_Code and Current_Session if not found
export const getCookieValue = (cookieName) => {
  let cookieValue = Cookies.get(cookieName) // Step 1: Get the value of the cookie
  if (!cookieValue) {
    console.warn(
      `Cookie "${cookieName}" not found! Setting default values: School_Code: "stage", Current_Session: "2024-2025"`,
    ) // Log warning
    // Step 2: Set default cookies
    Cookies.set('School_Code', 'stage9')
    Cookies.set('Current_Session', '2025-2026')
    Cookies.set('Login_Id', 'swipetouch')
    Cookies.set('schoolCode', 'stage9')
    Cookies.set('currentSession', '2025-2026')
    Cookies.set('loginId', 'swipetouch')
    cookieValue =
      cookieName === 'School_Code'
        ? 'stage'
        : cookieName === 'Current_Session'
          ? '2024-2025'
          : 'swipetouch' // Step 3: Assign value based on cookieName
  }
  return cookieValue // Step 4: Return the cookie value (existing or newly set)
}
export const getCookiesByName = (cookieName) => {
  let cookieValue = Cookies.get(cookieName)
  return cookieValue
}
export const setCookieValues = (cookieData, expiryMinutes = 120) => {
  const {
    schoolCode,
    LOGINID,
    SCHOOLID,
    currentSession,
    ROLEID,
    USERID,
    USERTYPE,
    USERDESIGNATION,
    NAME,
    IMAGE,
    App_Type,
    School_Name,
    classSecId,
    classId,
  } = cookieData
  const expiryTime = 120 / (24 * 60) // Convert minutes to days
  const options = { expires: expiryTime }
  Cookies.set('schoolCode', schoolCode, options)
  Cookies.set('loginId', LOGINID, options)
  Cookies.set('schoolId', SCHOOLID, options)
  Cookies.set('currentSession', currentSession, options)
  Cookies.set('roleId', ROLEID, options)
  Cookies.set('userId', USERID, options)
  Cookies.set('userType', USERTYPE, options)
  Cookies.set('userDesignation', USERDESIGNATION, options)
  Cookies.set('name', NAME, options)
  Cookies.set('image', IMAGE, options)
  Cookies.set('App_Type', App_Type, options)
  Cookies.set('School_Name', School_Name, options)
  Cookies.set('isTimedOut', 'false', options)
  Cookies.set('classSecId', classSecId, options)
  Cookies.set('classId', classId, options)

}
export const isAuthenticated = () => {
  const timeOutValue = Cookies.get('isTimedOut')

  const requiredCookies = [
    'schoolCode',
    'loginId',
    'schoolId',
    'currentSession',
    'roleId',
    'userId',
    'userType',
    'userDesignation',
  ]

  // Check if all required cookies are set
  const allCookiesPresent = requiredCookies.every((cookie) => Cookies.get(cookie))
  return allCookiesPresent && timeOutValue !== 'true'
}
// Function to check if a cookie exists
export const checkCookieExists = (cookieName) => {
  return !!Cookies.get(cookieName) // Step 1: Check if the cookie exists and return boolean
}
// Function to validate student ID
export const validateStudentId = (studentId) => {
  if (!studentId || typeof studentId !== 'string' || studentId.trim() === '') {
    throw new Error('Invalid student ID provided.') // Step 1: Throw error for invalid student ID
  }
}
// Function to validate files
export const validateFiles = (files) => {
  const maxFileSize = 5 * 1024 * 1024 // 5 MB file size limit
  const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'] // Example allowed file types
  if (!files || !Array.isArray(files)) {
    throw new Error('Files should be an array.') // Step 1: Throw error if files is not an array
  }
  for (const file of files) {
    // Step 2: Check file type
    if (!allowedFileTypes.includes(file.type)) {
      throw new Error(`File type ${file.type} is not allowed.`) // Step 3: Throw error for invalid file type
    }
    // Step 4: Check file size
    if (file.size > maxFileSize) {
      throw new Error(`File ${file.name} exceeds the size limit of 5 MB.`) // Step 5: Throw error for exceeding file size
    }
  }
}
// open pdf files in new window
export const openWindowWithPost = (url, data) => {
  // Create a new window with specified size
  const newWindow = window.open('', '_blank', 'width=860,height=680')
  var form = newWindow.document.createElement('form')
  // form.target = "_blank";
  form.method = 'POST'
  form.action = url
  form.style.display = 'none'
  for (var key in data) {
    var input = newWindow.document.createElement('input')
    input.type = 'hidden'
    input.name = key
    input.value = data[key]
    form.appendChild(input)
  }
  // document.body.appendChild(form);
  // Append the form to the new window's document
  newWindow.document.body.appendChild(form)
  form.submit()
  // document.body.removeChild(form);
  newWindow.document.body.removeChild(form)
}
// Convert FormData to a plain JavaScript object
export const formDataToObject = (formData) => {
  const obj = {}
  formData.forEach((value, key) => {
    // Handle multiple values (e.g., for checkboxes with the same name)
    if (obj[key]) {
      if (Array.isArray(obj[key])) {
        obj[key].push(value)
      } else {
        obj[key] = [obj[key], value]
      }
    } else {
      obj[key] = value
    }
  })
  return obj
}
// Convert formData to URL string
export const formDataToUrlString = (data) => {
  const params = new URLSearchParams(data)
  return params.toString()
}
// get sessions
export const getSessions = async (additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!') // Throw error if cookie is not found
    }
    const schoolCode = getCookieValue('School_Code') // Step 3: Get the school code from the cookie
    const loginId = getCookieValue('Login_Id') // Step 3: Get the school code from the cookie
    const formData = new FormData()
    formData.append('getSessions', '1') // Step 6: Add the student ID to FormData
    formData.append('schoolCode', schoolCode) // Step 7: Add the school code to FormData
    formData.append('loginId', loginId) // Step 7: Add the school code to FormData
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data', // Step 13: Specify content type for form data
    })
    return response // Step 14: Return the response from the API
  } catch (error) {
    console.error('Error fetching sessions:', error) // Step 15: Log any errors
    throw error // Step 16: Re-throw the error to be handled by the calling function
  }
}

// get classes
export const getClasses = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getClasses=1`,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all classes', err.message) // Handle errors
  }
}
// get streams
export const getSchoolDetails = async () => {
  try {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getSchoolDetails=1`,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all streams', err.message) // Handle errors
  }
}
// get streams
export const getStreams = async () => {
  try {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getStreams=1`,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all streams', err.message) // Handle errors
  }
}
// get sections by class
export const getSectionsByClass = async (classId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getSectionsByClass=1&classId=${classId}`,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all sections by classes', err.message) // Handle errors
  }
}
// get students
export const getStudentsByClassSectionSession = async (classId, classSecId, session) => {
  try {
    if (!checkCookieExists('schoolCode')) {
      throw new Error('School_Code cookie not found!') // Throw error if cookie is not found
    }
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    const formData = new FormData()
    formData.append('getStudentsByClassSectionSession', '1') // Step 6: Add the student ID to FormData
    formData.append('classId', classId) // Step 6: Add the student ID to FormData
    formData.append('classSecId', classSecId) // Step 6: Add the student ID to FormData
    formData.append('session', session) // Step 6: Add the student ID to FormData
    formData.append('schoolCode', schoolCode) // Step 7: Add the school code to FormData
    formData.append('loginId', loginId) // Step 7: Add the school code to FormData
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data', // Step 13: Specify content type for form data
    })
    return response // Step 14: Return the response from the API
  } catch (error) {
    console.error('Error fetching sessions:', error) // Step 15: Log any errors
    throw error // Step 16: Re-throw the error to be handled by the calling function
  }
}

export const getSubjects = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getSubjects=1`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while adding map roles', err.message) // Handle errors
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!') // Throw error if cookie is not found
    }
    const schoolCode = getCookieValue('School_Code') // Step 3: Get the school code from the cookie
    const loginId = getCookieValue('Login_Id') // Step 3: Get the school code from the cookie
    const formData = new FormData()
    formData.append('getSubjects', '1') // Step 6: Add the student ID to FormData
    formData.append('schoolCode', schoolCode) // Step 7: Add the school code to FormData
    formData.append('loginId', loginId) // Step 7: Add the school code to FormData
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data', // Step 13: Specify content type for form data
    })

    return response // Step 14: Return the response from the API
  }
}
// get sections
export const getSections = async (additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('schoolCode')) {
      throw new Error('School_Code cookie not found!') // Throw error if cookie is not found
    }
    const schoolCode = getCookieValue('schoolCode') // Step 3: Get the school code from the cookie
    const loginId = getCookieValue('Login_Id') // Step 3: Get the school code from the cookie
    const formData = new FormData()
    formData.append('getSections', '1') // Step 6: Add the student ID to FormData
    formData.append('schoolCode', schoolCode) // Step 7: Add the school code to FormData
    formData.append('loginId', loginId) // Step 7: Add the school code to FormData
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data', // Step 13: Specify content type for form data
    })
    return response // Step 14: Return the response from the API
  } catch (error) {
    console.error('Error fetching sections:', error) // Step 15: Log any errors
    throw error // Step 16: Re-throw the error to be handled by the calling function
  }
}
// get religions
export const getReligions = async (additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getReligions', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
// get localities
export const getLocalities = async (additionalData = {}, files = []) => {
  try {
    // if (!checkCookieExists('School_Code')) {
    //   throw new Error('School_Code cookie not found!')
    // }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getLocalities', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
// get houses
export const getHouses = async (additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getHouses', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getSocialCategories = async (additionalData = {}, files = []) => {
  try {
    // if (!checkCookieExists('School_Code')) {
    //   throw new Error('School_Code cookie not found!')
    // }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getSocialCategories', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getBloodGroups = async (additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getBloodGroups', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getMotherTongues = async (additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getMotherTongues', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getOtherCategories = async () => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getOtherCategories', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getLanguages = async (additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getLanguages', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getConcessions = async (additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getConcessions', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getSchoolBoards = async (additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getSchoolBoards', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getQualifications = async (additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getQualifications', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getOccupations = async (additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getOccupations', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getRelations = async (additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getRelations', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getBanks = async (additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getBanks', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getReceiptsByStudent = async (studentId, session, additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getReceiptsByStudent', '1')
    formData.append('studentId', studentId)
    formData.append('session', session)
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/getCommonData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const viewReceipt = async (receiptNo, masterAccountId, additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    // formData.append('viewReceipt', '1');
    formData.append('receipt_id', receiptNo)
    formData.append('master_account', masterAccountId)
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    Object.keys(additionalData).forEach((key) => {
      formData.append(key, additionalData[key])
    })
    openWindowWithPost(`${BASE_URL}/FeeReceiptNewPDF.php`, formDataToObject(formData))
  } catch (error) {
    console.error('Error fetching admit card:', error)
    throw error
  }
}
export const getLibraryIssues = async (studentId, additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('library', 'currentissue')
    formData.append('issuedto', 'student')
    formData.append('member_id', studentId)
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(
      `${BASE_URL}/LibraryAppAPI.php`,
      'POST',
      formData,
      {
        'Content-Type': 'multipart/form-data',
      },
    )
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getStudentFeedbacks = async (studentId, session, additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('get_feedback_by_student_id', '1')
    formData.append('student_id', studentId)
    formData.append('session', session)
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(
      `${BASE_URL}/AcademicFeedbackController.php`,
      'POST',
      formData,
      {
        'Content-Type': 'multipart/form-data',
      },
    )
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}

export const getAllClustersBySection = async (
  student_type,
  Class_Sec_Id,
  group_type = 'Regular',
) => {
  try {
    const formData = new FormData()
    formData.append('get_all_clusters_by_type_class_sec_id', '1') // Step 6: Add the student ID to FormData
    formData.append('group_type', group_type) // Step 6: Add the student ID to FormData
    formData.append('student_type', student_type) // Step 6: Add the student ID to FormData
    formData.append('Class_Sec_Id', Class_Sec_Id) // Step 6: Add the student ID to FormData

    return await axios.get(
      `${BASE_URL}/universal_apis.php?get_all_clusters_by_type_class_sec_id=1&group_type=${group_type}&student_type=${student_type}&Class_Sec_Id=${Class_Sec_Id}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
      formData,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting fee clusters', err.message)
  }
}

export const applyFeeStructureStudent = async (
  data
) => {
  const schoolCode = getCookieValue('School_Code')
  const loginId = getCookieValue('Login_Id')
  data.append('schoolCode', schoolCode)
  data.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/FeeStructureApply1.php`, data)
  } catch (err) {
    console.log('Error while getting fee clusters', err.message)
  }
}

export const getMasterAccountNames = async () => {
  try {
    return await axios.get(
      `${BASE_URL}/Master_Account_1.php?get_Master_Account_Name=1&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting fee clusters', err.message) // Handle errors
  }
}

export const getAllClustersByGroupType = async (group_type) => {
  try {
    return await axios.get(
      `${BASE_URL}/universal_apis.php?get_all_clusters=1&group_type=${group_type}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting fee clusters by group type', err.message) // Handle errors
  }
}

export const getClusterBySessionAndGroupType = async (session, group_type) => {
  try {
    return await axios.get(
      `${BASE_URL}/universal_apis.php?get_all_clusters_by_session=1&group_type=${group_type}&session=${session}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting fee clusters by group type and session', err.message) // Handle errors
  }
}

export const getMonthsOrder = async (session) => {
  try {
    return await axios.get(
      `${BASE_URL}/FeeControlNew_1.php?get_months_order=1&session=${session}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting months order', err.message) // Handle errors
  }
}

export const getAllPaymentModes = async () => {
  try {
    return await axios.get(`${BASE_URL}/universal_apis.php?get_payment_modes=1&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting payment modes', err.message) // Handle errors
  }
}

export const getAllAttendanceMonths = async (session) => {
  try {
    return await axios.get(
      `${BASE_URL}/Monthly_Attendance_Options.php?session=${session}&get_months=1&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting attendance months', err.message) // Handle errors
  }
}
export const getAllClassSectionData = async () => {
  try {
    return await axios.get(
      `${BASE_URL}/universal_apis.php?getClassDetails_JSON=1&Class_All=1&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all class section data', err.message) // Handle errors
  }
}
export const getSchoolsSugestionFromSchoolCode = async (schoolCode) => {
  try {
    return await axios.get(
      `https://swiftcampus.com/SearchSchoolCodeAPI.php?Domain_type=DEVELOPEMENT&School_Code=${schoolCode}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all class section data', err.message) // Handle errors
  }
}
export const getStudentsBySessionClassSection = async (session, class_id, sec_id) => {
  // schoolCode=stage9&loginId=swipetouch&getStudentsByClassSectionSession=1&classId=1&classSecId=1&session=2024-2025
  try {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?Client_Type=NOCHECK&getStudentsByClassSectionSession=1&classId=${class_id}&classSecId=${sec_id}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while canceling fee receipt', err.message) // Handle errors
  }
}

export const getAllSubjects = async (enabled = false) => {
  // schoolCode=stage9&loginId=swipetouch&deleteSection=1&classSecId=28
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getSubjects=1${enabled ? '&enabled=1' : ''
      }`,
      // {
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      // },
    )
  } catch (err) {
    console.log('Error while getting subjects', err.message)
  }
}

export const getAllStaff = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getAllStaff=1`,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all classes', err.message) // Handle errors
  }
}

export const getSchoolName = async () => {
  const schoolId = getCookieValue('schoolId')
  //
  try {
    return await axios.get(`${BASE_URL}/universal_apis.php?get_school_name=1&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting school name', err.message) // Handle errors
  }
}

export const getDiscountBySession = async (session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getAllDiscountsBySession=1&session=${session}`,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all discounts', err.message) // Handle errors
  }
}

export const getMaritialStatus = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getMaritalStatuses=1`,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all discounts', err.message) // Handle errors
  }
}

export const getTemplates = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getTemplates=1`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all templates', err.message) // Handle errors
  }
}

export const getTerms = async (templateId, Session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getTermsCombinationsByTemplate=1&templateId=${templateId}&session=${Session}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all terms by template', err.message) // Handle errors
  }
}